// removed by extract-text-webpack-plugin
module.exports = {"control-box":"_FUa9","toggle-wrapper":"_3d6m","small-txt":"_EYo4","switch":"_34HF","slider":"_3MpY","round":"_2PBq"};


//////////////////
// WEBPACK FOOTER
// ./checkout/components/toggle/style.css
// module id = wMfb
// module chunks = 4